

'use strict';

angular.module('pulianiBookStoreApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('legalDisclaimer', {
        url: '/legalDisclaimer',
        templateUrl: 'app/legal_disclaimer/legal_disclaimer.html',
        controller: 'LegalDisclaimerCtrl'
      });
  });
